import React from 'react';
import { Link } from 'react-router-dom';

/* ========== Style ========== */
import { StyledLive } from './GoLiveOnboardingStyle';

export default function LiveOnboarding() {
  /* ========== New Component ========== */
  return (
    <StyledLive>
      <div className="buttons-container">
        <button>
          <Link to={'/Events/new'}>
            Create Event <span>Schedule an audio or video event for later</span>
          </Link>
        </button>
        <button>
          <Link to={'/streaming'}>
            Go live <span>Create an instant audio or video event </span>
          </Link>
        </button>
        <button>
          Publish on Play <span>Publish video or ausio content instantly</span>
        </button>
      </div>
    </StyledLive>
  );
}
